<template>
  <div :class="`absolute flex h-screen w-screen text-yellow-light bg-opacity-90 ${currentTheme}`" >
  <div class="z-0 h-screen flex text-yellow-light">
    <div class="h-full min-h-screen site-content flex justify-between items-center w-screen text-left overflow-hidden">
      <div>
            <div class="pl-20">
              <small class="info-text from-evilRed">{{rattrapage  ? module.title : $t.enquete.sur_titre_enquete}}</small>
              <h2 class="grand-title" v-if="module && module.title" :class="rattrapage ? 'mb-10 mt-10': ''">{{!rattrapage ? module.title : module.metas['catch_up_title']}}</h2>

              <div class="mt-4 mb-8 1480:mb-10 1480:mt-20 font-bold" v-if="!rattrapage">{{$t.enquete.texte_duree}} <span :class="`font-bariol text-l text-left text-yellow-light rounded-md ml-2 bg-${currentTheme} pr-4 pl-4 pb-3 pt-2 mb-2 `" v-if="module && module.title">{{module.metas.duration || 0}} {{$t.enquete.texte_minutes}}</span></div>
              <div class="flex flex-wrap mb-8 1480:mb-20" v-if="!rattrapage">
                <span>{{$t.enquete.texte_gain}}</span>
                <span v-for="score in scores" :key="score.title" :class="`font-bariol font-bold text-l text-left flex text-yellow-medium rounded-md ml-2 bg-${currentTheme} pr-4 pl-4 pb-3 pt-2 mb-2 `">
                  <span class="skill-icon mr-1" v-html="icons[score.type]"></span>
                  {{score.value}} points {{score.title}}
                </span>
              </div>
          <div class="flex">
            <ShadowButton class="pr-2" v-if="!rattrapage" :theme="`${currentTheme}-light-yellow`" @click="$emit('nextstep', {action: 'prev', transition: 'down'})">{{$t.buttons.bouton_retour}}</ShadowButton>
            <ShadowButton class="pl-2" :theme="`light-yellow-${currentTheme}`" @click="continueAction()">{{$t.buttons.bouton_continuer}}</ShadowButton>
          </div>
        </div>
      </div>
      <img :src="enquete.cover" alt="" class="rounded-md h-[60%] left-6 relative -rotate-3" style="border-width: 16px;">
    </div>
  </div>
  </div>
</template>

<script>
import ShadowButton from "../../components/ShadowButton";
import {mapState} from "vuex";

const iconset = {
  legal: `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M25.5749 31.2612H10.4021C9.67655 31.262 8.97478 31.5156 8.42127 31.9769C7.86776 32.4382 7.49831 33.0775 7.37847 33.7813H28.5986C28.4787 33.0775 28.1093 32.4382 27.5557 31.9769C27.0022 31.5156 26.3005 31.262 25.5749 31.2612Z" fill="#FFF16F"/><path d="M37.4118 27.2205L24.5089 14.5257L20.855 18.1194L33.7442 30.8142C34.2415 31.2221 34.8759 31.4323 35.5228 31.4036C36.1697 31.3748 36.7823 31.1092 37.2402 30.6589C37.698 30.2085 37.9681 29.6061 37.9974 28.9698C38.0266 28.3336 37.8128 27.7096 37.3981 27.2205H37.4118Z" fill="#FFF16F"/><path d="M26.2319 11.4963L19.7051 5.08153C19.6411 5.01792 19.583 4.94876 19.5316 4.8749L11.0316 13.2348C11.1067 13.2854 11.1771 13.3425 11.2417 13.4055L17.7731 19.8248C17.8344 19.8896 17.8908 19.9587 17.9421 20.0314L26.442 11.676C26.3677 11.6212 26.2974 11.5611 26.2319 11.4963Z" fill="#FFF16F"/><path d="M26.7186 11.0474C26.9408 11.2628 27.2402 11.3835 27.5522 11.3835C27.8641 11.3835 28.1635 11.2628 28.3857 11.0474L29.0206 10.4185C29.1301 10.3109 29.217 10.1831 29.2762 10.0424C29.3355 9.90175 29.366 9.75097 29.366 9.5987C29.366 9.44643 29.3355 9.29565 29.2762 9.15499C29.217 9.01432 29.1301 8.88652 29.0206 8.77888L22.4938 2.34163C22.3846 2.23338 22.2548 2.14746 22.1117 2.08882C21.9687 2.03019 21.8152 2 21.6602 2C21.5052 2 21.3518 2.03019 21.2087 2.08882C21.0656 2.14746 20.9358 2.23338 20.8267 2.34163L20.1918 2.96155C20.0823 3.06918 19.9954 3.19698 19.9361 3.33765C19.8769 3.47832 19.8464 3.62909 19.8464 3.78136C19.8464 3.93363 19.8769 4.08441 19.9361 4.22508C19.9954 4.36575 20.0823 4.49355 20.1918 4.60118L26.7186 11.0474Z" fill="#FFF16F"/><path d="M10.7628 13.8808C10.6543 13.7723 10.525 13.6862 10.3822 13.6275C10.2394 13.5689 10.0862 13.539 9.9315 13.5394C9.77614 13.5391 9.62226 13.5691 9.47878 13.6277C9.3353 13.6863 9.20508 13.7724 9.09566 13.8808L8.4608 14.5053C8.35128 14.6129 8.26441 14.7407 8.20513 14.8814C8.14586 15.022 8.11535 15.1728 8.11535 15.3251C8.11535 15.4773 8.14586 15.6281 8.20513 15.7688C8.26441 15.9095 8.35128 16.0373 8.4608 16.1449L14.9876 22.5687C15.2098 22.784 15.5092 22.9047 15.8211 22.9047C16.1331 22.9047 16.4325 22.784 16.6547 22.5687L17.2896 21.9398C17.3991 21.8321 17.4859 21.7043 17.5452 21.5637C17.6045 21.423 17.635 21.2722 17.635 21.1199C17.635 20.9677 17.6045 20.8169 17.5452 20.6762C17.4859 20.5356 17.3991 20.4078 17.2896 20.3001L10.7628 13.8808Z" fill="#FFF16F"/><path d="M30.3681 34.4557H5.60367C4.64792 34.4557 3.73131 34.8291 3.05549 35.4938C2.37967 36.1585 2 37.06 2 38H33.9717C33.9717 37.06 33.592 36.1585 32.9162 35.4938C32.2404 34.8291 31.3238 34.4557 30.3681 34.4557Z" fill="#FFF16F"/></svg>`,
  actor: `<svg width="40" height="40" viewBox="0 0 13 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 0C12.5523 0 13 0.447715 13 1V18.2105C13 18.7628 12.5523 19.2105 12 19.2105H1C0.447715 19.2105 0 18.7628 0 18.2105V1C0 0.447716 0.447716 0 1 0H12ZM9.09986 14.9078C9.09986 15.4601 9.54757 15.9078 10.0999 15.9078H10.6999C11.2521 15.9078 11.6999 15.4601 11.6999 14.9078V14.2565C11.6999 13.7042 11.2521 13.2565 10.6999 13.2565H10.0999C9.54757 13.2565 9.09986 13.7042 9.09986 14.2565V14.9078ZM9.09986 10.9309C9.09986 11.4832 9.54757 11.9309 10.0999 11.9309H10.6999C11.2521 11.9309 11.6999 11.4832 11.6999 10.9309V10.2796C11.6999 9.7273 11.2521 9.27959 10.6999 9.27959H10.0999C9.54757 9.27959 9.09986 9.7273 9.09986 10.2796V10.9309ZM9.09986 6.95376C9.09986 7.50605 9.54757 7.95376 10.0999 7.95376H10.6999C11.2521 7.95376 11.6999 7.50605 11.6999 6.95376V6.30241C11.6999 5.75013 11.2521 5.30241 10.6999 5.30241H10.0999C9.54757 5.30241 9.09986 5.75013 9.09986 6.30241V6.95376ZM9.09986 2.97688C9.09986 3.52917 9.54757 3.97688 10.0999 3.97688H10.6999C11.2521 3.97688 11.6999 3.52917 11.6999 2.97688V2.32553C11.6999 1.77325 11.2521 1.32553 10.6999 1.32553H10.0999C9.54757 1.32553 9.09986 1.77325 9.09986 2.32553V2.97688ZM5.2 14.9078C5.2 15.4601 5.64772 15.9078 6.2 15.9078H6.8C7.35228 15.9078 7.8 15.4601 7.8 14.9078V14.2565C7.8 13.7042 7.35229 13.2565 6.8 13.2565H6.2C5.64772 13.2565 5.2 13.7042 5.2 14.2565V14.9078ZM5.2 10.9309C5.2 11.4832 5.64772 11.9309 6.2 11.9309H6.8C7.35228 11.9309 7.8 11.4832 7.8 10.9309V10.2796C7.8 9.7273 7.35229 9.27959 6.8 9.27959H6.2C5.64772 9.27959 5.2 9.7273 5.2 10.2796V10.9309ZM5.2 6.95376C5.2 7.50605 5.64772 7.95376 6.2 7.95376H6.8C7.35228 7.95376 7.8 7.50605 7.8 6.95376V6.30241C7.8 5.75013 7.35229 5.30241 6.8 5.30241H6.2C5.64772 5.30241 5.2 5.75013 5.2 6.30241V6.95376ZM5.2 2.97688C5.2 3.52917 5.64772 3.97688 6.2 3.97688H6.8C7.35228 3.97688 7.8 3.52917 7.8 2.97688V2.32553C7.8 1.77325 7.35229 1.32553 6.8 1.32553H6.2C5.64772 1.32553 5.2 1.77325 5.2 2.32553V2.97688ZM1.30015 14.9078C1.30015 15.4601 1.74786 15.9078 2.30015 15.9078H2.90014C3.45243 15.9078 3.90014 15.4601 3.90014 14.9078V14.2565C3.90014 13.7042 3.45243 13.2565 2.90014 13.2565H2.30015C1.74786 13.2565 1.30015 13.7042 1.30015 14.2565V14.9078ZM1.30015 10.9309C1.30015 11.4832 1.74786 11.9309 2.30015 11.9309H2.90014C3.45243 11.9309 3.90014 11.4832 3.90014 10.9309V10.2796C3.90014 9.7273 3.45243 9.27959 2.90014 9.27959H2.30015C1.74786 9.27959 1.30015 9.7273 1.30015 10.2796V10.9309ZM1.30015 6.95376C1.30015 7.50605 1.74786 7.95376 2.30015 7.95376H2.90014C3.45243 7.95376 3.90014 7.50605 3.90014 6.95376V6.30241C3.90014 5.75013 3.45243 5.30241 2.90014 5.30241H2.30015C1.74786 5.30241 1.30015 5.75013 1.30015 6.30241V6.95376ZM1.30015 2.97688C1.30015 3.52917 1.74786 3.97688 2.30015 3.97688H2.90014C3.45243 3.97688 3.90014 3.52917 3.90014 2.97688V2.32553C3.90014 1.77325 3.45243 1.32553 2.90014 1.32553H2.30015C1.74786 1.32553 1.30015 1.77325 1.30015 2.32553V2.97688Z" fill="#FFF16F"/></svg>`,
  quality: `<svg width="40" height="40" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.76696 0H7.83551L6.40377 2.50288L4.76696 0ZM10.1083 0H13.3132L11.7195 2.43714L10.1083 0ZM12.9685 5.13633L10.5499 16.0796L17.9998 5.13633H12.9685ZM-1.25885e-05 5.01449C0.0723541 5.0907 0.171385 5.13642 0.281829 5.13642H5.34364L7.57936 16.1521L0.079979 5.13642L-1.25885e-05 5.01449ZM6.12069 5.13633L8.66873 17.6952C8.70302 17.8743 8.85535 18 9.03819 18H9.04198C9.21719 18 9.37336 17.8781 9.41143 17.7028L12.1918 5.13633H6.12069ZM17.9885 4.37429H12.9966L12.1764 3.13216L14.1112 0.17147C14.1836 0.0647925 14.3017 0 14.4312 0H14.4959C14.614 0 14.7245 0.0571644 14.7968 0.152423L17.9885 4.37429ZM5.78762 3.58338L5.97994 3.24684L3.96869 0.17147C3.89633 0.0647925 3.77826 0 3.64875 0H3.58401C3.46594 0 3.35547 0.0571644 3.28311 0.152423L0.0913937 4.37429H5.33366L5.78762 3.58338ZM6.71866 4.37429H6.2121L6.44824 3.96276L8.60399 0.190517C8.67254 0.0723974 8.79824 0 8.93534 0H8.99248C9.11816 0 9.24004 0.0647925 9.30859 0.17147L11.7233 3.8256L12.0852 4.37429H11.8833H11.3615H6.71866Z" fill="#FFF16F"/></svg>`
};

export default {
  emits: ["nextstep"],
  inject: ['$t'],
  components: {
     ShadowButton
  },
  props: {
    title:{
      type: String,
      default: 'UN TITRE'
    },
    courses: {
      type: Object,
      default: undefined
    },
    moduleId:{
      type: String,
      default: undefined
    },
    rattrapage:{
      type: Boolean,
      default: false
    }
  },
  computed:{
    module() {
      const module = this.moduleId || this.currentModule
      return this.courses && module ? this.courses[0].modules.find( m => m.id === module) : undefined
    },
    icons(){
      return iconset
    },
    ...mapState({
      currentTheme: state => {
        return state.currentTheme
      },
      currentModule: state => state.gamestatus.currentModule,
      customBg() {
        return {
          'background-image':`url(${this.enquete.thumbAndBgPic})`,
        }
      },
      enquete: state => state.enquete.enquete
    }),

    scores() {
      if (!this.module || !this.module.scores)
        return []

      // Get module scores value for each score type
      const titles = {
        legal: this.$t.enquete.score_juridique,
        actor: this.$t.enquete.score_acteur,
        quality: this.$t.enquete.score_qualite,
      }

      return Object.keys(titles).reduce((scores, type) => {
        if (!this.module.scores[type])
          return scores

        scores.push({
          type: type,
          title: titles[type],
          value: this.module.scores[type]
        }) 

        return scores
      }, [])
    }
  },
  mounted() {
  },
  methods:{
    continueAction(){
      if(this.rattrapage){
         this.$router.push('/game?r=1')
      }else{
        this.$emit('nextstep', {action: 'next', transition: 'up'})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.blue-quest {
 .rounded{
   @apply bg-blue-quest
 }
}
.green-quest {
  .rounded{
    @apply bg-green-quest
  }
}
.yellow-quest {
  .rounded{
    @apply bg-yellow-quest
  }
}
.pink-quest {
  .rounded{
    @apply bg-pink-quest
  }
}
</style>
